import { useEffect, useState } from 'react';

// ==============================|| HOOKS - SYSTEM COLOR SCHEME ||============================== //

const QUERY = '(prefers-color-scheme: dark)';

/**
 * Whether the operating system is currently asking for a dark UI.
 *
 * Subscribed rather than read once. The template's `getWindowScheme()` sampled `matchMedia` during
 * render and nothing ever re-ran it, so a dashboard left open on "auto" stayed light after the OS
 * flipped to dark in the evening — until someone reloaded the page.
 */
const useSystemColorScheme = (): boolean => {
  const [isDark, setIsDark] = useState<boolean>(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const media = window.matchMedia(QUERY);
    const listener = (event: MediaQueryListEvent) => setIsDark(event.matches);

    // Re-read on mount: the OS may have changed between the initial state and this effect.
    setIsDark(media.matches);

    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, []);

  return isDark;
};

export default useSystemColorScheme;
